module.exports = __webpack_public_path__ + "img/birthday.03f62012.webp";